import React from 'react';
import { fetchVersion, getVersionState, recordServerSha, shortSha } from '../../../hooks/useBuildVersionCheck';

/** Observed build identity is informational; it does not imply a connected game session. */
export const EntryBuildStatus: React.FC = () => {
  const [build, setBuild] = React.useState(() => {
    const state = getVersionState();
    return state.hasData && state.lastServerSha ? { sha: state.lastServerSha, env: state.env ?? '' } : null;
  });
  const [checking, setChecking] = React.useState(!build);
  React.useEffect(() => {
    if (build) return;
    let active = true;
    void fetchVersion().then(version => {
      if (!active || !version) return;
      recordServerSha(version.sha, version.env);
      setBuild({ sha: version.sha, env: version.env });
    }).finally(() => { if (active) setChecking(false); });
    return () => { active = false; };
  }, [build]);
  return <span data-testid="build-version-chip" style={{ display: 'inline-block', fontSize: 11, color: 'var(--entry-build-ink, var(--tome-ink-muted, #a4a7ad))', letterSpacing: '0.025em' }}>
    {build ? `build ${shortSha(build.sha)}${build.env ? ` · ${build.env}` : ''}` : checking ? 'Build information…' : 'Build information unavailable'}
  </span>;
};
